import { get } from '.';

export function GetLiveDashboardAgents(options = {}) {
	return get<any>("/app/api/live_dashboard_agents", options);
}
